<ng-content></ng-content>
<span class="uni-label__required" *ngIf="required">*</span>
<span class="uni-label__tip" *ngIf="labelTip.length">
  <ng-content select="[uniLabelTip]"></ng-content>
</span>
<span class="uni-label__suffix" *ngIf="labelSuffix.length">
  <ng-content select="[uniLabelSuffix]"></ng-content>
</span>
